import React, {useContext, useEffect, useState} from "react"
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import {CSVLink} from 'react-csv';
import {FormattedMessage} from "react-intl";
import { DwellFilterContext } from "../../commons/context/DwellFilterContext";
import { FiltersStateInitializer } from "../../commons/defaultInitializer/FiltersStateInitializer";
import { FilterConverter } from "../../commons/filter/FilterConverter";
import { getAPIGatewayDataFromParent } from "../../handler/ParentDataHandler";
import { getPackageDrilDownRequestFilter, logOperationalMetric } from "../../util/CommonUtils";
import { paginatedFetch } from "../../commons/api/PaginatedFetchUtil";
import { chainWalk } from "../../commons/CommonUtils";
import { FeatureConfigContext } from "../../commons/context/FeatureConfigContext";
import { FEATURES } from "../../commons/constants/CommonConstants";
import { ViewDataContext } from "../../commons/context/view/ViewDataContext";

const ExportCSV = (props) => {

    const csvLink = React.useRef();
    const {viewModelFilter} = useContext(DwellFilterContext);
    const [csvData, setCSVData] = useState([]);
    const {configViewModel} = useContext(FeatureConfigContext);
    const {viewModel} = useContext(ViewDataContext);

    useEffect(() => {
        if (csvData.length > 0) {
            csvLink.current.link.click();
        }
    }, [csvData]);

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let stationCode = params.get('stationCode');

    const selectedTabForPackages = props.selectedTabForPackages;
    const addShipOptionForExportApiEnabled = chainWalk(() => configViewModel.featureStatus[FEATURES.IS_SHIP_OPTION_FILTER_FOR_EXPORT_API_ENABLED], false);
    async function exportCSVFile2() {
        // const {filters, stationCode, leg, size} = props.data;
        const filters = getPackageDrilDownRequestFilter(viewModel.metricResult, selectedTabForPackages, viewModelFilter.selectedPackageStatusListTile, viewModel.stationTimeZone, addShipOptionForExportApiEnabled);
        const leg = "FORWARD";
        const size = 10000;
        var initializedFilters = FiltersStateInitializer(filters, [])
            var packageStatusMap = {}
            const modifiedRequest = await FilterConverter(initializedFilters, null, leg, packageStatusMap, null, filters.packageStatuses? filters.packageStatuses:  [], false);
            var lastUpdatedRange;
            const startTime = Date.now();
            if (initializedFilters.lastUpdatedStart !== "" || initializedFilters.lastUpdatedEnd !== "") {
                lastUpdatedRange = {
                    "startTime" : initializedFilters.lastUpdatedStart ? new Date(initializedFilters.lastUpdatedStart).getTime() / 1000 : (new Date(initializedFilters.lastUpdatedEnd).getTime() - 24 * 60 * 60 * 1000) / 1000 ,
                    "endTime": initializedFilters.lastUpdatedEnd ? new Date(initializedFilters.lastUpdatedEnd).getTime() / 1000 : (new Date(initializedFilters.lastUpdatedStart).getTime() + 24 * 60 * 60 * 1000) / 1000
                }  
            }
            const metricProcessName = "SCC_PACKAGE_DOWNLOAD";

            const baseRequestBody = {
                "nodeId": stationCode,
                "packageStatusMap" : packageStatusMap,
                "filters": modifiedRequest,
                "lastUpdatedRange" : lastUpdatedRange,
                "size": size,
                "startingIndex": 0
            };

            try {
                const { results } = await paginatedFetch(baseRequestBody, getAPIGatewayDataFromParent);

                if (results === null) {
                    logOperationalMetric(startTime, metricProcessName, "getDrillDownData", false);
                    return [];
                }

                logOperationalMetric(startTime, metricProcessName, "getDrillDownData", true);
                return results;
            } catch (error) {
                logOperationalMetric(startTime, metricProcessName, "getDrillDownData", false);
                return [];
            }
    }
    const fileName = props.filePrefix + "_" + new Date().toISOString().slice(0, 10) + ".csv";

    return (
        <div>
            <Row width="100%" alignmentHorizontal="right" spacingInset="none" spacing={"none"}>
                
                <Button type="tertiary" size="small" onClick={async () => {
                    const result = await exportCSVFile2();
                    setCSVData(result);
                }}>
                    <FormattedMessage id="stage.exportCSV" defaultMessage="Export To CSV"/>
                </Button>
                <CSVLink data={csvData}
                         ref={csvLink}
                         filename={fileName}
                         target="_blank"
                         fileencoding="UTF-8"/>
            </Row>
        </div>
    )
}

export default ExportCSV


// WEBPACK FOOTER //
// ./src/components/exportCsv/ExportCSV.js